import api from '../../apiConfig/apiConfig';
import { Post, Get, Put, Delete } from '../base/baseAjax';

let addTweets = function (param) {
	return Post({
		url: api.tweet.addTweets,
		bodyParam: param,
	});
};
let getTweetsDetail = param => {
	return Get({
		url: api.tweet.getTweetsDetail + param.id,
	});
};
let editTweets = param => {
	return Post({
		url: api.tweet.editTweets + param.id,
	});
};
let retryTweets = param => {
	return Post({
		url: api.tweet.retryTweets,
		PathParam: param,
		config: {
			timeout: 60000,
		},
	});
};
let getCount = param => {
	return Get({
		url: api.tweet.getCount,
		UrlParam: param,
	});
};
let removeTwitter = param => {
	return Delete({
		url: api.tweet.removeTwitter,
		PathParam: param,
	});
};
let getTweetsShare = (id, serviceId) => {
	return Get({
		url: api.tweet.getTweetsShare,
		PathParam: id,
		UrlParam: serviceId,
	});
};
let getCommentList = (id, sid, body) => {
	return Post({
		url: api.tweet.getCommentList,
		PathParam: id,
		bodyParam: body,
		UrlParam: sid,
	});
};
let twitterComment = (id, sid, body) => {
	return Post({
		url: api.tweet.twitterComment,
		PathParam: id,
		bodyParam: body,
		UrlParam: sid,
	});
};
let articleTranslate = param => {
	return Post({
		url: api.tweet.articleTranslate,
		bodyParam: param,
	});
};

// tiktok互动设置
let tiktokInteractionSettings = params => {
	return Get({
		url: api.tweet.tiktokInteractionSettings,
		UrlParam: params,
	});
};

// tiktok隐私级别
let tiktokPrivacyLevels = params => {
	return Get({
		url: api.tweet.tiktokPrivacyLevels,
		UrlParam: params,
	});
};

export default {
	addTweets,
	getTweetsDetail,
	getCount,
	editTweets,
	retryTweets,
	removeTwitter,
	getTweetsShare,
	getCommentList,
	twitterComment,
	articleTranslate,
	tiktokInteractionSettings,
	tiktokPrivacyLevels,
};
